import { BaseLayoutReport } from 'app/components/common/BaseLayoutReport'
import { data } from './data'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import { useVerifyPermissionAndRedirect } from 'app/common/use-verify-permission-redirect'
import { useEffect } from 'react'
import { ModulePermissionEnum } from 'app/common/permission-module'

const MarketingContainer = () => {
  const { t } = useTranslation()

  const { isHavePermissionAndGoBack } = useVerifyPermissionAndRedirect()

  useEffect(() => {
    isHavePermissionAndGoBack(
      ModulePermissionEnum.MARKETING,
      R.strings.marketing,
    )
  }, [t])
  
  return (
    <BaseLayoutReport
      data={data}
      titleI18nKey={R.strings.marketing}
      modulePermission={ModulePermissionEnum.MARKETING}
    />
  )
}

export default MarketingContainer
